import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { BaseWidgetSettingsComponent } from '../../widget/base/base-widget';
import { WidgetDataService } from '../../widget/data/widget-data.service';
import { DxButtonModule, DxFormModule, DxPopupModule } from 'devextreme-angular';
import { MachineInfoMainService } from 'src/app/shared/services/machine-info.service';
import { MachineInfoWidgetConfig } from '../machine-info.component';
import { Subject, takeUntil } from 'rxjs';
import { MachineInfo } from 'src/api/generated';

@Component({
  selector: 'app-machine-info-settings',
  standalone: true,
  imports: [DxFormModule, DxButtonModule, DxPopupModule],
  templateUrl: './machine-info-settings.component.html',
  styleUrl: './machine-info-settings.component.scss'
})
export class MachineInfoSettingsComponent extends BaseWidgetSettingsComponent<MachineInfoWidgetConfig> implements OnInit, OnDestroy {
  public selectOptions: {id: string; name: string;}[] = [];

  private _unsubscriber: Subject<any> = new Subject<any>();

  constructor(
    widgetDataService: WidgetDataService<MachineInfoWidgetConfig>,
    private _miSvc: MachineInfoMainService
  ) {
    super(widgetDataService);

    this.formData = {
      machineId: null,
      refreshInterval: 0,
      title: 'Machine info'
    }
  }

  ngOnInit(): void {
    // Get lidt of machines for select box
    this._miSvc.dataSource.load().then((data) => {
      this.selectOptions = data.map((r: MachineInfo) => {
        return { id: r.Id, name: r.Name };
      });
    });
  }

  ngOnDestroy(): void {
    this._unsubscriber.next(null);
    this._unsubscriber.complete();
  }

  /**
   * Form submit method with validation.
   *
   * @memberof MachineViewSettingsComponent
   */
  public override onSubmitModal(): void {
    if (this.formData && this.formData.machineId) {
      let machName = this.selectOptions.find(option => option.id === this.formData?.machineId)?.name ?? '';
      this.formData.subtitle = machName;
      this.formData.machineName = machName;
    }
    super.onSubmitModal();
  }
}
